(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parlor-blog-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Run after DOM is ready just in case
  function onReady(fn){ if(document.readyState!=='loading'){fn()} else {document.addEventListener('DOMContentLoaded',fn)} }

  onReady(function() {
    // Find THIS instance of the section using its unique class
    var root = document.querySelector('.parlor-blog-slider');
    if (!root || !window.jQuery) return;
    var $ = window.jQuery;

    var track = $(root).find('.parlor-blog-slider-track');
    if (!track.length || track.hasClass('slick-initialized')) return;

    // Helper to read data-attrs safely (fallback to defaults)
    function readIntAttr(el, name, fallback) {
      var val = el.getAttribute(name);
      if (val == null || val === '') return fallback;
      var n = parseInt(val, 10);
      return isNaN(n) ? fallback : n;
    }

    // Read config from data-* attributes (don’t rely on dataset)
    var slidesMobile  = readIntAttr(root, 'data-slides-mobile',  1);
    var slidesTablet  = readIntAttr(root, 'data-slides-tablet',  2);
    var slidesDesktop = readIntAttr(root, 'data-slides-desktop', 3);
    var slidesWide    = readIntAttr(root, 'data-slides-wide',    4);

    var prevArrow = $(root).find('.parlor-blog-slider-arrow.prev');
    var nextArrow = $(root).find('.parlor-blog-slider-arrow.next');

    track.slick({
      slidesToShow: slidesWide,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      adaptiveHeight: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
        { breakpoint: 1440, settings: { slidesToShow: slidesDesktop } },
        { breakpoint: 1024, settings: { slidesToShow: slidesTablet } },
        { breakpoint: 768,  settings: { slidesToShow: slidesMobile } }
      ]
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parlor-custom-process"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener("click", function(e) {
    var btn = e.target.closest(".parlor-play-btn");
    if (!btn) return;

    var wrap = btn.closest(".parlor-custom-process-video-wrap");
    if (!wrap) return;

    var video = wrap.querySelector("video");
    if (!video) return;

    btn.remove();
    video.play();
  });
})();

(function() {
  // Run after DOM is ready just in case
  function onReady(fn){ if(document.readyState!=='loading'){fn()} else {document.addEventListener('DOMContentLoaded',fn)} }

  onReady(function() {
    // Find THIS instance of the section using its unique class
    var root = document.querySelector('.parlor-custom-process');
    if (!root || !window.jQuery) return;
    var $ = window.jQuery;

    var track = $(root).find('.parlor-custom-process-grid');
    if (!track.length || track.hasClass('slick-initialized')) return;

    // Helper to read data-attrs safely (fallback to defaults)
    function readIntAttr(el, name, fallback) {
      var val = el.getAttribute(name);
      if (val == null || val === '') return fallback;
      var n = parseInt(val, 10);
      return isNaN(n) ? fallback : n;
    }

    // Read config from data-* attributes (don’t rely on dataset)
    var slidesMobile  = readIntAttr(root, 'data-slides-mobile',  1);
    var slidesTablet  = readIntAttr(root, 'data-slides-tablet',  3);
    var slidesDesktop = readIntAttr(root, 'data-slides-desktop', 5);
    var slidesWide    = readIntAttr(root, 'data-slides-wide',    6);

    var prevArrow = $(root).find('.parlor-blog-slider-arrow.prev');
    var nextArrow = $(root).find('.parlor-blog-slider-arrow.next');

    track.slick({
      slidesToShow: slidesWide,
      slidesToScroll: 2,
      swipeToSlide: true,
      autoplay:false,
      arrows: true,
      dots: false,
      infinite: false,
      draggable:true,
      adaptiveHeight: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
        { breakpoint: 1600, settings: { slidesToShow: slidesDesktop } },
        { breakpoint: 1440, settings: { slidesToShow: slidesDesktop } },
        { breakpoint: 1024, settings: { slidesToShow: slidesTablet } },
        { breakpoint: 768,  settings: { slidesToShow: slidesMobile } }
      ]
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parlor-custom-product-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Simple, accessible tab controller
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.parlor-custom-product-tabs .parlor-tab');
    if (!btn) return;

    var tabsRoot = btn.closest('[data-parlor-tabs]');
    if (!tabsRoot) return;
    var list = tabsRoot.querySelector('.parlor-tabs-list');
    var panels = tabsRoot.querySelectorAll('.parlor-tab-content');
    var media = tabsRoot.querySelectorAll('.parlor-tab-media');
    var tabs = list.querySelectorAll('.parlor-tab');

    // Deactivate
    tabs.forEach(function(t){ t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); t.setAttribute('tabindex','-1'); });
    panels.forEach(function(p){ p.classList.remove('is-active'); p.setAttribute('hidden',''); });
    media.forEach(function(p){ p.classList.remove('is-active'); p.setAttribute('hidden',''); });

    // Activate clicked
    btn.classList.add('is-active');
    btn.setAttribute('aria-selected','true');
    btn.setAttribute('tabindex','0');

    var controls = btn.getAttribute('aria-controls');
    var controls_m = btn.getAttribute('aria-media');
    var panel = tabsRoot.querySelector('#' + CSS.escape(controls));
    var medias = tabsRoot.querySelector('#' + CSS.escape(controls_m));
    if (panel) {
      panel.classList.add('is-active');
      panel.removeAttribute('hidden');
    }
    if (medias) {
      medias.classList.add('is-active');
      medias.removeAttribute('hidden');
    }
  });

  // Keyboard support (Left/Right/Home/End)
  document.addEventListener('keydown', function(e) {
    var activeTab = e.target.closest('.parlor-custom-product-tabs .parlor-tab[aria-selected="true"]');
    if (!activeTab) return;

    var list = activeTab.closest('.parlor-tabs-list');
    var tabs = Array.from(list.querySelectorAll('.parlor-tab'));
    var idx = tabs.indexOf(activeTab);
    var nextIdx = idx;

    if (e.key === 'ArrowRight') nextIdx = (idx + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') nextIdx = (idx - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') nextIdx = 0;
    else if (e.key === 'End') nextIdx = tabs.length - 1;
    else return;

    e.preventDefault();
    tabs[nextIdx].click();
    tabs[nextIdx].focus();
  });

  document.addEventListener('click', function(e) {
    var spec = e.target.closest('.parlor-tab-content .parlor-tab-specs li strong');
    console.log('click');
    if (!spec) return;
    var list = e.target.closest('.parlor-tab-content .parlor-tab-specs li');
    list.classList.toggle("open");
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parlor-text-and-media"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener("click", function(e) {
    var btn = e.target.closest(".parlor-play-btn");
    if (!btn) return;

    var wrap = btn.closest(".parlor-text-and-media-wrap");
    if (!wrap) return;

    var video = wrap.querySelector("video");
    if (!video) return;

    btn.remove();
    video.play();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
